import React from "react";

import { roundToWhole, useSoilSightCurrency, useTranslation } from "utils";

/** A total as shown in both tables: whole euros, no sign. */
export const useEveryLineTotal = () => {
  const { formatCurrency } = useSoilSightCurrency();
  return (value: number) => formatCurrency(roundToWhole(value), { decimals: 0 });
};

type EveryLineDifferenceProps = {
  value: number;
  className?: string;
};

/** A difference as shown in both tables: signed and green or red, or a muted "—" when it rounds to zero. */
export const EveryLineDifference = ({ value, className = "" }: EveryLineDifferenceProps) => {
  const { t } = useTranslation("scenarioAnalysis");
  const { formatCurrency } = useSoilSightCurrency();
  const shown = roundToWhole(value);

  if (shown === 0) {
    return (
      <span className={`${className} every-line-cell--muted`}>
        <span aria-hidden>—</span>
        <span className="every-line-visually-hidden">{t("everyLine.noDifference")}</span>
      </span>
    );
  }

  return (
    <span className={`${className} every-line-cell--difference ${shown > 0 ? "every-line-cell--positive" : "every-line-cell--negative"}`}>
      {formatCurrency(shown, { decimals: 0, signDisplay: "always" })}
    </span>
  );
};

export default EveryLineDifference;
